import {
  EditSubmission,
  EditSubmission_editSubmission,
  Mutation,
  Mutation_submit,
  QuestionGroups,
  RetrieveAllSubmissions_findAllByUserId,
  Structure_structure_questionGroups_questions,
  StructureInput,
} from './graphqlTypes';

export * from './graphqlTypes';

export type QuestionGroup = QuestionGroups;

export type Question = Structure_structure_questionGroups_questions;

export type SubmitResult = Mutation;

export type SubmitResultData = Mutation_submit;

export type SubmitEditResult = EditSubmission;

export type SubmitEditResultData = EditSubmission_editSubmission;

export interface Submission {
  id?: string;
  externalId?: string;
  structure: StructureInput;
}

export type Submissions = RetrieveAllSubmissions_findAllByUserId[];
